import React from "react";
import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import { SITE } from "../data/site";

// Precise embed queries + user-provided Google Maps share links for the pin.
const MAPS = [
    {
        key: "pune",
        label: SITE.offices[0].label,
        address: SITE.offices[0].address,
        src: `https://www.google.com/maps?q=${encodeURIComponent(
            "Design Desire LLP, Royal Orchid A-1004, Katraj-Dehu Rd Bypass, Ambegaon Budruk, Pune 411046"
        )}&output=embed`,
        href: "https://maps.app.goo.gl/1J9EkyixJ1fFUWvr7?g_st=ac",
    },
    {
        key: "goa",
        label: SITE.offices[1].label,
        address: SITE.offices[1].address,
        src: `https://www.google.com/maps?q=${encodeURIComponent(
            "H. No. 171, Near Vadadev Temple, Honda, Sattari, North Goa 403506"
        )}&output=embed`,
        href: "https://maps.app.goo.gl/X8P7T7AUTKGZeq3U8?g_st=ic",
    },
];

export const StudiosMap = () => {
    return (
        <section
            id="studios"
            data-testid="studios-section"
            className="py-20 lg:py-28 bg-[#FAF9F6]"
        >
            <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-12 gap-6 lg:gap-12 mb-12">
                    <div className="col-span-12 lg:col-span-5">
                        <div className="overline text-[#4A4643] mb-6">
                            Visit us
                        </div>
                        <h2 className="font-serif text-4xl md:text-5xl font-light leading-[1.05] tracking-tight text-[#1A1A1A]">
                            Two <span className="text-[#8C7C6D]">studios</span>, one practice.
                        </h2>
                    </div>
                    <div className="col-span-12 lg:col-span-6 lg:col-start-7 flex items-end">
                        <p className="text-base lg:text-lg text-[#4A4643] leading-relaxed font-light max-w-lg">
                            Drop in by appointment. Coffee, drawings on the table, material samples at hand.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10">
                    {MAPS.map((m, i) => (
                        <motion.div
                            key={m.key}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.6, delay: i * 0.1 }}
                            data-testid={`map-card-${m.key}`}
                            className="bg-white border border-[#1A1A1A]/10"
                        >
                            <div className="aspect-[16/10] w-full bg-[#F0EFEA]">
                                <iframe
                                    title={`Map — ${m.label}`}
                                    src={m.src}
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0, filter: "grayscale(0.25) contrast(1.05)" }}
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    allowFullScreen
                                />
                            </div>
                            <div className="p-6 lg:p-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
                                <div>
                                    <div className="overline text-[#8C7C6D] mb-2">{m.label}</div>
                                    <p className="text-[15px] text-[#1A1A1A] leading-relaxed font-light max-w-sm">
                                        {m.address}
                                    </p>
                                </div>
                                <a
                                    href={m.href}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid={`map-open-${m.key}`}
                                    className="overline text-[#1A1A1A] dd-link inline-flex items-center gap-2 whitespace-nowrap"
                                >
                                    Open in Maps
                                    <ExternalLink size={14} strokeWidth={1.6} />
                                </a>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
